// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import 'react-times/css/classic/default.css';
  var Spinner = require('react-spinkit');
  
  
  class EditCourt extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        court_id: props.match.params.id,
        court_details: {
            court_name:'',
            venue_name:'',
            venue:'',
            game: '',
            size:'',
            field_type:'',
            surface_type:'',
            level:'',
            reference_courts:[]
        }, 
        game_arr: [],
        size_arr: [],
        courts_arr: [],
        field_arr: [],
        surface_arr:[],
        level_arr:[],
        ref_courts: [],
        temp_list_courts: [],
        temp_courts: [],
        success:false,
        message:'',
        loading: true
      };
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.onSelect = this.onSelect.bind(this);
      this.onChange = this.onChange.bind(this);
    }
  
    componentDidMount() {
        this.getDetails();
    }  

    getDetails(){
      this.setState({loading: true})
      const url = `${getLocationOrigin()}/court/get_court_details/?court_id=${this.state.court_id}`;
      const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            if(data.success){
              this.setState({success:data.success,message:data.message},()=>{this.setData(data)})
            }
            else{
              this.setState({success:data.success,message:data.message})
            }
           // alert("fix");
       })
       .catch(error => error)
    }

    getKeyByValue = (object, value) => {
      const keys = Object.keys(object); 
      return keys.find(key => object[key] === value); 
    }

    setData(data) {
      console.log('data',data)
      // console.log("testing get key by value",this.getKeyByValue(data.field_types,data.court_details.field_type))
      var new_value =  Object.assign({}, this.state.court_details);
      new_value['court_name'] = data.court_details.name
      new_value['size'] = this.getKeyByValue(data.sizes,data.court_details.size)
      new_value['field_type'] = this.getKeyByValue(data.field_types,data.court_details.field_type)
      new_value['surface_type'] = this.getKeyByValue(data.surface_types,data.court_details.surface_type)
      new_value['level'] = data.court_details.level
      new_value['venue'] = data.court_details.venue
      new_value['venue_name'] = data.court_details.venue_name
      new_value['game'] = data.court_details.game.pk
      new_value['reference_courts'] = data.court_details.reference_courts
      console.log('data.court_details',data.court_details)

      const ref_courts = data.court_details.reference_courts
      console.log('ref_courts',ref_courts)
      console.log('courts',data.courts)
      const court_data = data.courts.filter(court => ref_courts.includes(court.id))
      console.log('reference_courts',court_data)

      this.setState({ref_courts:court_data, court_details:new_value, game_arr: data.game_list, courts_arr: data.courts, size_arr: data.sizes, field_arr: data.field_types, surface_arr: data.surface_types, level_arr: data.levels,loading:false})
    }

    postUpdateBooking(details,props) {
        console.log(details)
        const url = `${getLocationOrigin()}/court/update_court/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                          'court_id': this.state.court_id,
                                          'court_details': details
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(response=>{  
            console.log('response',response)
            alert(response.message)
            history.back()
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }

    handleChange(event) {
        const name = event.target.name;
        const target = event.target
        const value = target.value
        console.log(name,value)
        var new_value =  Object.assign({}, this.state.court_details);
        new_value[name] = value
        this.setState({court_details: new_value});
        // this.getAmount(this.state.equipment_details)
    }

    handleSubmit(event) {
        console.log('handle')
        event.preventDefault();
        console.log('Submit');
        this.postUpdateBooking(this.state.court_details ,this.props)
      }

    onSelect(optionsList, selectedItem) {
        var name = optionsList.name ;
        if(name === 'court'){
            this.state.temp_list_courts.push(optionsList.id)
            this.state.temp_courts.push(optionsList)
            var new_value =  Object.assign({}, this.state.court_details);
            new_value['reference_courts'] = this.state.temp_list_game
            this.setState({ court_details: new_value, ref_courts: this.state.temp_courts});
        }
    }

    onChange(dataItem,event){
      var name = event.dataItem.name
      if(name === 'court'){
        var new_value =  Object.assign({}, this.state.court_details);
        new_value['reference_courts'] = dataItem.map(x => x.id)
        this.setState({court_details:new_value,ref_courts:dataItem.map(x =>x)});
      }
    }
  
    render() {
      console.log('court_details',this.state.court_details);

        // console.log(this.state.court_details);
        // console.log(this.state.size_arr)

      return(
        <div> 
          <div>
            <button style={{borderColor:'#115691',borderRadius:'50%',color:'#115691',background:'none'}} onClick={() => history.back()}><i className="fa fa-arrow-left" aria-hidden="true"></i></button>
          </div>
          {this.state.loading ? 
            <div className="loading-overlay" style={{display:'flex',background:'none',top:0}}>
              <Spinner name="line-scale-pulse-out" color="#115691" fadeIn='quarter'/>
            </div>
          : 
            <div style={styles.container}> 

              <div className="row col-md-9 table-bordered" style={styles.table}>
                <div style={styles.main_header} className="col-md-12">
                  Edit Court
                </div>
                { this.state.success ?
                  <form  className="validated-form form-horizontal">

                    <div style={styles.items} className="col-md-12">
                      <div style={styles.item_header} className="col-md-6">
                        Court Name
                      </div>
                      <input style={styles.input} name="court_name" value={this.state.court_details.court_name} onChange={this.handleChange}/>
                    </div>

                    <div style={styles.items} className="col-md-12">
                      <div style={styles.item_header} className="col-md-6">
                        Venue
                      </div>
                      <input style={styles.input} name="venue_name" value={this.state.court_details.venue_name} readonly="readonly" disabled/>
                    </div>

                  <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Game
                    </div>
                   <select name="game" className="col-md-6" style={styles.item_body} value={this.state.court_details.game}
                     onChange={this.handleChange}>
                      {
                         this.state.game_arr.map((game,index)=>(
                           <option key={game.pk} value={game.pk}>{game.name}</option>
                          ))
                       }
                   </select>
                  </div>

                  <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Size
                    </div>
                   <select name="size" className="col-md-6" style={styles.item_body} value={this.state.court_details.size}
                     onChange={this.handleChange}>
                      { 
                         Object.keys(this.state.size_arr).map((key,index)=>(
                           <option key={key} value={key}>{this.state.size_arr[key]}</option>
                          ))
                      }
                   </select>
                  </div>

                  <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Field Type
                    </div>
                   <select name="field_type" className="col-md-6" style={styles.item_body} value={this.state.court_details.field_type}
                     onChange={this.handleChange}>
                      { 
                         Object.keys(this.state.field_arr).map((key,index)=>(
                           <option key={key} value={key}>{this.state.field_arr[key]}</option>
                          ))
                      }
                   </select>
                  </div>

                  <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Surface Type
                    </div>
                   <select name="surface_type" className="col-md-6" style={styles.item_body} value={this.state.court_details.surface_type}
                     onChange={this.handleChange}>
                      { 
                         Object.keys(this.state.surface_arr).map((key,index)=>(
                           <option key={key} value={key}>{this.state.surface_arr[key]}</option>
                          ))
                      }
                   </select>
                  </div>

                  <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Level
                    </div>
                   <select name="level" className="col-md-6" style={styles.item_body} value={this.state.court_details.level}
                     onChange={this.handleChange}>
                      { 
                         Object.keys(this.state.level_arr).map((key,index)=>(
                           <option key={key} value={key}>{this.state.level_arr[key]}</option>
                          ))
                      }
                   </select>
                  </div>

                  
                  <div style={styles.items} className="col-md-12">
                      <div style={styles.item_header} className="col-md-6">
                        Reference Courts
                      </div>
                      <div style={styles.item_ref_court} className="col-md-6">
                          <Multiselect
                            id="3"  
                            placeholder="Reference Courts"
                            data={this.state.courts_arr}
                            value = {this.state.ref_courts}
                            textField='court'
                            onSelect={this.onSelect} 
                            onChange={this.onChange}
                            filter='contains' 
                           />
                      </div>      

                  </div>
                 
                  <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
                    <div style={styles.button_submit} className="col-md-12">
                      <input className="button1" type="submit" value="Submit" onClick={this.handleSubmit} style={{backgroundColor:'rgb(17, 86, 145)',
                        border:'none'}}/>
                    </div>
                  </div>
                    
                </form>
                :
                <div style={styles.message}>{this.state.message}</div>
              }
              </div>
            </div>
        }
        </div>
      );
    }
  }
  
  export default EditCourt;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/editCourt/EditCourt.js